import dayjs from 'helpers/dayjs';
// This doesn't include the country code (+1)
const PHONE_NUMBER_LENGTH = 10;
const formatPhoneNumber = str => {
    //Filter only numbers from the input
    let cleaned = str.replace(/\D/g, '');
    cleaned = cleaned.substring(1);

    if (cleaned.length > PHONE_NUMBER_LENGTH) return str;
    //Check if the input is of correct length
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const [, first, second, third] = match;
        return `${first}-${second}-${third}`;
    }

    return '';
};

export const isAdult = dateOfBirth => {
    const ADULT_AGE = 18;
    const diffInYears = dayjs().diff(dayjs(dateOfBirth), 'year');
    return diffInYears >= ADULT_AGE;
};

export { formatPhoneNumber };
